var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNoRfiDs(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_4025_16429)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M17.0858 3.5H4.5C3.39543 3.5 2.5 4.39543 2.5 5.5V17.5C2.5 17.6792 2.52356 17.8528 2.56775 18.0181L4.5 16.0858V6.5C4.5 5.94803 4.9472 5.50052 5.49904 5.5L15.0858 5.5L17.0858 3.5Z",
    fill: "#6B7684"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.651 7.93482C12.4585 7.85693 12.234 7.85922 12.0333 7.96214C11.6933 8.14214 11.5333 8.54214 11.6733 8.90214C11.6743 8.90462 11.6752 8.90711 11.6762 8.90959L12.651 7.93482Z",
    fill: "#6B7684"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.0994 10.4864C10.0661 10.3102 10.0243 10.1356 9.9733 9.96214C9.8433 9.51214 9.3533 9.28214 8.9333 9.47214C8.5933 9.62214 8.4333 10.0121 8.5333 10.3721C8.6433 10.7521 8.6933 11.1421 8.7033 11.5521C8.70603 11.6641 8.70354 11.7768 8.69604 11.8898L10.0994 10.4864Z",
    fill: "#6B7684"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.16424 19.5H20.5C21.6046 19.5 22.5 18.6046 22.5 17.5V5.5C22.5 5.11793 22.3929 4.76088 22.207 4.45725L20.4566 6.20765C20.4848 6.30013 20.5 6.39829 20.5 6.5V16.5C20.5 17.0523 20.0523 17.5 19.5 17.5H9.16424L7.16424 19.5Z",
    fill: "#6B7684"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.7575 14.9067C11.8212 15.0177 11.9142 15.1136 12.0333 15.1821C12.4233 15.4021 12.9233 15.2421 13.0933 14.8321C13.3313 14.2748 13.5019 13.6838 13.5993 13.065L11.7575 14.9067Z",
    fill: "#6B7684"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.685 10.9792C15.6972 11.1675 15.7033 11.3551 15.7033 11.5421C15.7033 12.8521 15.4033 14.2121 14.8133 15.6021C14.6633 15.9621 14.8333 16.3821 15.1833 16.5521C15.5633 16.7421 16.0333 16.5621 16.2033 16.1621C16.8633 14.6021 17.2033 13.0421 17.2033 11.5421C17.2033 10.9136 17.1436 10.2781 17.0257 9.63854L15.685 10.9792Z",
    fill: "#6B7684"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.75 2.25L1.25 20.75H4.5L23 2.25H19.75Z",
    fill: "#6B7684"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_4025_16429"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNoRfiDs);
export default __webpack_public_path__ + "static/media/NoRFIDs.1150e8c4f804c0fdd645ff6284b89be5.svg";
export { ForwardRef as ReactComponent };